export enum UserStatusEnum {
  ACTIVE = "Ativo",
  BLOCKED = "Bloqueado",
  NOT_FOUND = "Excluído",
  DELETED = "Excluído",
  PENDING_UPDATE = "Pendente",
  INACTIVE = "Pendente",
}
